module.exports = __webpack_public_path__ + "static/media/location.8a20b340.svg";